const serviceLayout = require('../../includes/service-layout');

const serviceDetail = () => {
    serviceLayout();
}

module.exports=serviceDetail